import "../../assets/livechat.scss";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../components/common/Theme/theme";
import { darkTheme } from "../../components/common/Theme/darkTheme";
import CommonLayout from "../../components/common/layout";
import ChatHistory from "../../components/chat/chatHistory";
import { createContext, useState, useEffect } from "react";
import { Await, useParams } from "react-router-dom";
import { parseInstituteHash, getInfra, prepareAJAXData,decryptData,decodeId,makeInstituteHash,encodeId } from "../../../common";
import { getBaseUrl } from "../../../environment";
import NoChat from "../../components/common/noChat";
import { WebSocketProvider } from "./webSocketConnection";
import pageLoader from "../../assets/images/meritto.gif";
import axios from "axios";
import InvalidRequest from "./invalidRequest";
import { addISOWeekYears, parseJSON } from "date-fns";
import { gtmIntialize } from "../../components/common/gtmConfiguration";
import setCSSVariables from "../../components/common/Theme/themeToCSSVariables";
import {callByItems,echoTabName} from '../../../constants'

export const MyContext = createContext({
  collegeId: null,
  setCollegeId: () => null,
  instituteHash: null,
  setInstituteHash: () => null,
  collegeHash: null,
  setCollegeHash: () => null,
  candidate: null,
  setCandidate: () => {},
  chat: null,
  setChat: () => {},
  collegeId: null,
  setCollegeId: () => 5419,
  fetchAgain: null,
  setFetchAgain: () => {},
  leadMessage: null,
  setLeadMessage: () => {},
  jwtToken: null,
  setJwtToken: () => {},
  validateAuth: () => false,
  userDetails: null,
  setUserDetails: () => false,
  errorMessage: null,
  setErrorMessage: () => {},
  tabVal:null,
  setTabVal:()=>{},
  masking:null,
  setMasking:()=>{},
  mobileApp:null,
  setMobileApp:()=>{},
  callBy:null,
  setCallBy:()=>{},
  collegeDialcode:null,
  setCollegeDialcode:()=>{},
  appTheme:null,
  setAppTheme:()=>{}
});

let callBylocal = ''

const LiveChat = () => {
  let params = useParams();
  // let institute_id = parseInstituteHash(collegeHashData);

  const host = window.location.hostname;
  const subdomain = host.split('.')[0];
  let institute_id = "";
  let institute_hash = "";
  if (/^[a-z0-9]{10,}$/.test(subdomain)) {
    institute_id = decodeId(subdomain);
    institute_hash = subdomain;
  }
  if (!institute_id && params.institute_id) {
    institute_id = decodeId(params.institute_id);
    if(institute_id){
      institute_hash = params.institute_id;
    }
    else{
      institute_id = parseInstituteHash(parseInt(params.institute_id));
      institute_hash = encodeId(institute_id);
    }
  }
  let collegeHashData = makeInstituteHash(institute_id);
  const [instituteHash, setInstituteHash] = useState(institute_hash);
  const [collegeHash, setCollegeHash] = useState(collegeHashData);
  const [collegeId, setCollegeId] = useState(institute_id);
  const [candidate, setCandidate] = useState();
  const [chat, setChat] = useState([]);
  const [fetchAgain, setFetchAgain] = useState(false);
  const [leadMessage, setLeadMessage] = useState("");
  const [jwtToken, setJwtToken] = useState(null);
  const [ussidToken, setUssidToken] = useState(null);

  const [userDetails, setUserDetails] = useState(null);
  const [errorMessageState, setErrorMessageState] = useState(false);
  const [invalidRequest, SetInvalidRequest] = useState(false)
  const [tabVal, setTabVal] = useState('')
  const [masking, setMasking] = useState(false)
  const [sessionExpired, setSessionExpired] = useState(false)
  const [pidToken,setPidToken]=useState(false)
  const [mobileApp,setMobileApp]=useState(false)
  const [callBy,setCallBy]=useState(false)
  const [widgetLead,setWidgetLead] = useState(false)
  const [collegeDialcode,setCollegeDialcode] =useState('')
  const [appTheme, setAppTheme] = useState('')


  useEffect(() => {
    gtmIntialize();
    const getQueryParamsFromURL = () => {
      const searchParams = new URLSearchParams(window.location.search);
      const params = {};
      for (const [key, value] of searchParams) {
        params[key] = value;
      }
      return params;
    };



    // if (!process.env.REAsetWidgetLeadCT_APP_ALLOWED_HOST.includes(referrerUrl) || referrerUrl == "" || referrerUrl == undefined) {
    //     setJwtToken("")
    //     SetInvalidRequest(true)
    // }else{
        const params = getQueryParamsFromURL();
        if (params.source){
          setTabVal(echoTabName[params.source]);
        }
        if (!params.NPFSSID || params.NPFSSID == undefined){
          if(!params.npf_ussid || params.npf_ussid == undefined){
            SetInvalidRequest(true)
          }else{
            setUssidToken(() => params?.npf_ussid);
            setPidToken(() => params?.pid);
            setAppTheme(() => params?.app_theme)
          }
        }else{
         var decryptedParams= decryptData( params?.NPFSSID)
         decryptedParams=JSON.parse(decryptedParams);

         if(decryptedParams && decryptedParams.callBy )
         {
        //  if(decryptedParams && decryptedParams.iframeId){
        //   var opendIframe=localStorage.getItem("eoi")
        //   opendIframe = JSON.parse(opendIframe)
        //   if(opendIframe && opendIframe.includes(decryptedParams.iframeId)){
        //   } else{
        //     SetInvalidRequest(true)
        //   }
        //  }
          callBylocal = decryptedParams.callBy;
          setCallBy(()=> decryptedParams.callBy)
          setJwtToken(() => decryptedParams?.NPFSSID);
          if(decryptedParams && decryptedParams.userInfo){
            setWidgetLead(()=>decryptedParams.userInfo)
            // setCollegeId(()=>decryptedParams?.college_id)
          }
          if(decryptedParams.callBy == callByItems.widget){
            localStorage.setItem("eoi", []);
          }

         }else{
          setJwtToken(() => params?.NPFSSID);
         }
        }

    let referrerUrl = document.referrer?document.referrer:null;
    let { infra, institute_hash } = getInfra();
    if(!institute_hash){
      institute_hash=instituteHash
    }
      if (referrerUrl && instituteHash) {
        referrerUrl = referrerUrl.replace(instituteHash + ".", "");
      }
      let meritto_npf_backend_url = getBaseUrl("NPF_BACKEND", infra,"",institute_hash);
      let meritto_npf_url = getBaseUrl("NPF", infra,"",institute_hash);
      if (meritto_npf_backend_url && instituteHash) {
        meritto_npf_backend_url = meritto_npf_backend_url.replace(instituteHash + ".", "");
      }
      if (meritto_npf_url && instituteHash) {
        meritto_npf_url = meritto_npf_url.replace(instituteHash + ".", "");
      }
       if(!params?.npf_ussid){
      if(referrerUrl){
        if(!referrerUrl.includes(meritto_npf_url) && !referrerUrl.includes(meritto_npf_backend_url)){
      SetInvalidRequest(true)
    }}else{
      SetInvalidRequest(true)
    }
  }
    // }
  }, []);
  useEffect(() => {
    async function getwabaNo(widgetLead){
      try {
        const { infra, institute_hash } = getInfra();
        const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
        const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
        const post_data = prepareAJAXData({
          room_id: widgetLead.id ? 'cr_'+ widgetLead.id :'' ,
            url: `${meritto_service_url}/communication/v1/${collegeId}/get-last-wabano-for-widget`,
          });
        const response = await axios.post(
          `${meritto_node_url}/chat/${collegeHash}/getData`,
          post_data
        );
        if (response.status === 200) {
           let  waba_number = response?.data.data.last_waba_no
             widgetLead['waba_number']=waba_number
             if (response?.data?.data?.lead_id) {
               widgetLead['lead_id'] = response.data.data.lead_id
             }
             if ("echo_enabled" in response.data.data && response.data.data.echo_enabled === false) {
               widgetLead['echo_enabled'] = false
             }
             setCandidate(widgetLead)
        } else {
          console.error("Failed to fetch user details");
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    }
    if(widgetLead && widgetLead.waba_number){
      setCandidate(widgetLead)
     }if (widgetLead && (widgetLead.waba_number == '' || widgetLead.waba_number == undefined )){
      getwabaNo(widgetLead)
     }

  }, [widgetLead]);
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const { infra, institute_hash } = getInfra();
        const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
        const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
        const entity_service_url = getBaseUrl("ENTITY_SERVICES", infra,"india");

        const post_data = prepareAJAXData({
            token: jwtToken,
            // url: `${meritto_service_url}/entity/v1/get-token-details`,
            url: `${entity_service_url}/entity/v1/get-token-details/`,
          });

        
        const response = await axios.post(
          `${meritto_node_url}/chat/${collegeHash}/getData`,
          post_data,
          {
            headers: {
              'Content-Type': 'application/json',
              'ENTITYINFRA':infra
            },
          }
        );
        
        if (response.status === 200) {
         if(callBylocal == callByItems.widgetLead || callBy == callByItems.widgetLeadProfile)
         {
         let user_info=response?.data.data.user_details;
       const post_data = prepareAJAXData({
        user_id:user_info?.UserId,
        EntityType:user_info?.EntityType,
          user_role:user_info?.GroupId,
          entity_id:user_info?.EntityId,
          url: `${meritto_service_url}/communication/v1/${collegeId}/get-enabled-bots/whatsapp`,
        });

      const botConfigresponse = await axios.post(
        `${meritto_node_url}/chat/${collegeHash}/getData`,
        post_data
      );
      // setNiaaEnabled(botConfigresponse.data.data?.bot_enabled)
      var maskingVal=botConfigresponse && botConfigresponse.data && botConfigresponse.data.data && botConfigresponse.data.data.masking?botConfigresponse.data.data.masking:false
      var collegeDialcodeVal=botConfigresponse && botConfigresponse.data && botConfigresponse.data.data && botConfigresponse.data.data.collegeDialcode?botConfigresponse.data.data.collegeDialcode:'+91' 
      setMasking(maskingVal)
      setCollegeDialcode(collegeDialcodeVal)
    }

          setUserDetails(() => response?.data.data.user_details);
          const currentTime = Math.floor(Date.now() / 1000);
          if(response?.data.data.exp >0 && currentTime > response?.data.data.exp){
            setSessionExpired(true)
          }
          localStorage.setItem("access_token", jwtToken);
          localStorage.setItem("maxAge", response?.data.data.exp);
        } else {
          console.error("Failed to fetch user details");
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };
    if(jwtToken){
      fetchUserDetails();

    }

  }, [jwtToken]);
  useEffect(() => {
    const updateCollegeDialCode = async (userDetails) => {
               const { infra, institute_hash } = getInfra();
        const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
        const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
       const post_data = prepareAJAXData({
        user_id:userDetails?.UserId,
        EntityType:userDetails?.EntityType,
          user_role:userDetails?.GroupId,
          entity_id:userDetails?.EntityId,
          url: `${meritto_service_url}/communication/v1/${collegeId}/get-enabled-bots/whatsapp`,
        });

      const botConfigresponse = await axios.post(
        `${meritto_node_url}/chat/${collegeHash}/getData`,
        post_data
      );
      // setNiaaEnabled(botConfigresponse.data.data?.bot_enabled)
      var maskingVal=botConfigresponse && botConfigresponse.data && botConfigresponse.data.data && botConfigresponse.data.data.masking?botConfigresponse.data.data.masking:false
      var collegeDialcodeVal=botConfigresponse && botConfigresponse.data && botConfigresponse.data.data && botConfigresponse.data.data.collegeDialcode?botConfigresponse.data.data.collegeDialcode:'+91' 
      setMasking(maskingVal)
      setCollegeDialcode(collegeDialcodeVal)

    }

    const setUserData = async () => {
      if (ussidToken) {
      var userJsonData =decryptData(ussidToken);
      var userDetails =JSON.parse(userJsonData);
      if(userDetails){
        await updateCollegeDialCode(userDetails)
        const currentTime = Math.floor(Date.now() / 1000);
        setUserDetails(userDetails);
        if(userDetails?.exp >0 && currentTime> userDetails?.exp){
          setSessionExpired(true)
        }
        localStorage.setItem("access_token", ussidToken);
        localStorage.setItem("maxAge", userDetails?.exp);
        setCallBy(callByItems.mobile)
      }else{
        SetInvalidRequest(true)
      }
        if(pidToken){
          var condidateDetailsStr =decryptData(pidToken);
                  var condidateDetails=JSON.parse(condidateDetailsStr);
               if(condidateDetails && condidateDetails.user_id && condidateDetails.waba_number && condidateDetails.applicant_name && condidateDetails.from){

              var user_data={
                  id:condidateDetails.user_id,
                  mobile_no:condidateDetails.from,
                  name:condidateDetails.applicant_name,
                  waba_number:condidateDetails.waba_number,
                  country_dialcode:condidateDetails.country_dialcode,
                  m_token:condidateDetails.m_token,
                  profile_token:condidateDetails.profile_token,
                  lead_id: condidateDetails.lead_id || (condidateDetails.user_unique_id ? String(condidateDetails.user_unique_id).replace(/-/g, "") : "")
                }
                setCandidate(user_data)
                setMobileApp(true)
            };
          }
    }
  }
  setUserData();

  }, [ussidToken]);
  const validateAuth = () => {
    return new Promise((resolve, reject) => {
      const currentTime = Math.floor(Date.now() / 1000);
      setTimeout(() => {
        if (
          (jwtToken == localStorage.getItem("access_token") &&
          currentTime < Number(localStorage.getItem("maxAge"))) || (ussidToken == localStorage.getItem("access_token") &&
          currentTime < Number(localStorage.getItem("maxAge")))
        ) {
          resolve(true);
        } else {
          resolve(false);
        }
      }, 1000);
    });
  };

  useEffect(() => {
    setCSSVariables(theme, darkTheme);
  }, []);

 

  return (
    <ThemeProvider theme={appTheme == 3? darkTheme: theme}>
      <MyContext.Provider
        value={{
          instituteHash,
          setInstituteHash,
          collegeHash,
          setCollegeHash,
          collegeId,
          setCollegeId,
          candidate,
          setCandidate,
          chat,
          setChat,
          fetchAgain,
          setFetchAgain,
          leadMessage,
          setLeadMessage,
          jwtToken,
          setJwtToken,
          validateAuth,
          userDetails,
          setUserDetails,
          errorMessageState,
          setErrorMessageState,
          tabVal,
          setTabVal,
          masking,
          setMasking,
          mobileApp,
          callBy,
          collegeDialcode,
          setCollegeDialcode,
          appTheme
        }}
      >
        {invalidRequest?<InvalidRequest code={404} msg='Invalid Request' callBy={callBy} widget_id={candidate?candidate.id:null}/>:
        <WebSocketProvider>
          {(jwtToken || ussidToken)&& userDetails ? (
            <>{sessionExpired ? <InvalidRequest code={201} msg='User session has been expired' />:
            <>{callBy == callByItems.widgetLead || callBy == callByItems.widgetLeadProfile?<>{ candidate ?<div className="chat-iframe-widget"><ChatHistory /></div>:
              <InvalidRequest code={400} msg='Invalid Request' />}</>:null}
              {callBy == callByItems.widget || callBy == callByItems.livechat || callBy == callByItems.mobile?
             <CommonLayout candidateName={candidate ? candidate.name : ""}  callBy={callBy} appTheme={appTheme}>
              {candidate ? <ChatHistory /> :<>{callBy != callByItems.widget? <NoChat />:null}</>}
            </CommonLayout>:
            <>{callBy == callByItems.widgetLead || callBy == callByItems.widgetLeadProfile ?null:<InvalidRequest code={401} msg='Invalid Request' />}</>}
            </>
            }</>
          ) : invalidRequest ? <InvalidRequest /> :(
            <div className="page-loader">
              <div>
                <img src={pageLoader} alt="Echo - Meritto" className="pl-img" />
              </div>
            </div>
          )}
        </WebSocketProvider>}
      </MyContext.Provider>
    </ThemeProvider>
  );
};

export default LiveChat;